import React, { useState, useEffect, useRef } from 'react'
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import { useFormik, FormikProvider, FieldArray } from 'formik';
import { FocusError } from 'focus-formik-error';
import { format } from 'date-fns';
import Api from '../../../../Api';
import * as Yup from "yup";
import { AdminTraficDetailsSchema } from '../../../../ValidationScema';
import { adminMainUrl } from '../../../../Config';
import Modal from 'react-bootstrap/Modal';
import { getChargehead, getChargeheadByServiceType } from '../../../../Redux/action/MasterAction';
import { useDispatch, useSelector } from 'react-redux';

const ImportTarrifDetailsModal2 = ({ handleShow, handleClose, show, modalData, rate, addTableId, tableDetailsId, tableId, modal, traficDetails, setUpdateTraficDetails, updateTraficDetails, loadingAirline, airlineOptions, reset_Form, setReset_Form, editDetail,       
  editAirlineCode  }) => {
    const closeButtonRef = useRef(null);
    const dispatch = useDispatch();
    const [currentRowData, setCurrentRowData] = useState(null);
    const [weightUnit, setWeightUnit] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [tableIdData, setTableIdData] = useState(1)
    const [cargoType, setCargoType] = useState([]);
    const [chargeHeadOptions, setChargeHeadOptions] = useState([]);

    let [showAirline, setShowAirline] = useState(false);


    let servicetypeOptions = [
        { label: "Freight Forwarding", value: "FREIGHT_FORWARDING" },
        { label: "Custom Clearence", value: "CUSTOM_CLEARENCE" },
        { label: "Both", value: "BOTH" },
    ]

    const matchingDetail = modalData.find(detail => detail.tableId === tableId);

    // Get the airline code if both conditions are met (data exists and tableId matches)
    const initialAirlineCode = matchingDetail ? matchingDetail.airline_code : ''; // Set as empty string if no data
    const GetWeightUnit = async () => {
        try {
            const data = await Api(`${adminMainUrl}/api/weight-unit/get`, "GET");
            const options = data?.data
                ?.filter((item) => item.status === true).map((item) => ({
                    WeightUnitId: item.id,
                    value: item.name,
                    label: item.name,
                }));
            setWeightUnit(options);
        } catch (error) {
            setWeightUnit([]);

            console.error("Error fetching data:", error);
        }
    };
    const GetCargoType = async () => {
        try {
            const data = await Api(`${adminMainUrl}/api/cargo-type/get`, "GET");
            const options = data?.data?.map(item => ({
                cargoId: item.id,
                value: item.name,
                label: item.name,
            }));
            setCargoType(options);

        } catch (error) {
            setCargoType([]);

            console.error("Error fetching data:", error);
        }
    };


    useEffect(() => {
        dispatch(getChargehead());
    }, []);


    const {
        loadingChargehead,
        chargeheadData,
        chargeheadDataError,

        loadingChargeheadByService,
        ChargeheadByServiceData,
        ChargeheadByServiceDataError
    } = useSelector(state => state?.MasterReducer);



    const modalRef = useRef(null);
    const handleEditClick = (detail) => {
        if (modalRef.current) {
            modalRef.current.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }
        setCurrentRowData(detail);
    };

    const formik = useFormik({
        initialValues: {
            service_type: "",
            airline_code: "", // Pre-fill airline_code if available, otherwise empty
            charge_head: '',
            buying_price: '',
            base_price: '',
            // selling_price: '',
            narration: '',
            valid_upto: '',
            chargeable_weight: "",
            surcharge: "",
            ams_charge_hawb: "",
            ams_charge_mawb: "",
            pickup_price: "",
            drop_price: "",
            custom_clearance_charge: ""
        },
        validationSchema: Yup.object({
            service_type: Yup.string().required("Please select the service type."),
            airline_code: Yup.string().when('service_type', {
                is: (val) => val === 'FREIGHT_FORWARDING' || val === 'BOTH',
                then: () => Yup.string().required('Please select airline code.'),
                otherwise: () => Yup.string().notRequired(),
            }),
            charge_head: Yup.string().required('Please select charge head.'),
            buying_price: Yup.number().required('Please enter buying price. '),
            base_price: Yup.number().required('Please enter base price '),
            narration: Yup.string().required('Please enter narration '),
            valid_upto: Yup.date().required('Please enter valid upto '),
            chargeable_weight: Yup.string().required("Please enter Chargeable Weight"),
            surcharge: Yup.string().required("Please enter  surcharge"),
            pickup_price: Yup.string().notRequired(),
            drop_price: Yup.string().notRequired(),
            custom_clearance_charge: Yup.string().notRequired(),
        }),
        onSubmit: (values, { resetForm }) => {
            setIsSubmitting(true);
            values.tableId = tableId;
            if (values.service_type == "CUSTOM_CLEARENCE") {
                values.airline_code = ""
            }
            setTableIdData(values.tableId);
            // closeButtonRef.current.click();
            handleClose()
            if (currentRowData) {
                const updatedDetails = updateTraficDetails.map((detail) =>
                    detail === currentRowData ? { ...values, valid_upto: values.valid_upto.split('T')[0] } : detail
                );
                setUpdateTraficDetails(updatedDetails);
                setCurrentRowData(null);
                setIsSubmitting(false);
            } else {
                setUpdateTraficDetails([...updateTraficDetails, values]);
                setIsSubmitting(false);
            }

            resetForm({
                values: {
                    ...formik.initialValues, // Reset all fields to initial values
                    airline_code: formik.values.airline_code, // Preserve the airline_code
                },
            });
        },
    });

    useEffect(() => {
        if (reset_Form) {
            formik.resetForm();
            setReset_Form(false);
        }
    }, [reset_Form])


    useEffect(() => {
        if (formik.values.service_type) {
            dispatch(getChargeheadByServiceType(formik.values.service_type));
        }

        if (formik.values.service_type == "FREIGHT_FORWARDING" || formik.values.service_type == "BOTH") {
            setShowAirline(true);
        } else {
            setShowAirline(false);
        }

    }, [formik.values.service_type]);

    useEffect(() => {
        if (ChargeheadByServiceData) {
            let arr = [];
            ChargeheadByServiceData.map(val => { if (val.status) { arr.push({ value: val.name, label: val.name }) } });
            setChargeHeadOptions(arr);



        }
    }, [loadingChargeheadByService, ChargeheadByServiceData])

    // useEffect(() => {
    //   if (initialAirlineCode) {
    //     formik.setValues(initialAirlineCode);
    //   }
    // }, [initialAirlineCode]);
    useEffect(() => {
        if (rate?.length > 0 && rate[0].quote_tarrif) {
            setUpdateTraficDetails(rate[0].quote_tarrif);
        }
    }, [rate]);

    useEffect(() => {
  if (editDetail) {
    setCurrentRowData(editDetail);
  } else {
    setCurrentRowData(null);
  }
}, [editDetail]);
    useEffect(() => {
        if (currentRowData) {
            formik.setValues(currentRowData);
        }
    }, [currentRowData]);
    const handleDeleteClick = (index) => {
        const updatedDetails = updateTraficDetails.filter((_, i) => i !== index);
        // closeButtonRef.current.click();
        handleClose();
        setUpdateTraficDetails(updatedDetails);
    };
    useEffect(() => {
        GetCargoType();
        GetWeightUnit();
    }, []);
    const groupedData = updateTraficDetails.reduce((acc, detail) => {
        if (!acc[detail.airline_code]) {
            acc[detail.airline_code] = [];
        }
        acc[detail.airline_code].push(detail);
        return acc;
    }, {});

    const customStyles = {
        control: (base) => ({
            ...base,
            height: 29,
            minHeight: 29,
            display: 'flex',
            alignItems: 'center',
        }),
        placeholder: (base) => ({
            ...base,
            display: 'flex',
            alignItems: 'center',
            fontSize: '12px',
            fontWeight: "600",
            color: '#808080',
        }),
        menu: (base) => ({
            ...base,
            fontSize: '12px',
        }),
        option: (base) => ({
            ...base,
            fontSize: '12px',
        }),
        singleValue: (base) => ({
            ...base,
            fontSize: '12px',
            display: 'flex', // Ensure singleValue aligns center vertically
            alignItems: 'center',
        }),
    };

    return (
        <>

            <Modal show={show} onHide={handleClose}
                size="xl"
                backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>New Rate</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="main_detail_form " id="main_id_sec">
                        <form onSubmit={formik.handleSubmit}>
                            <FocusError formik={formik} />
                            <div className="Air_Export_Form_bg">
                                <div className="Air_Export_bg_main">
                                    <div className="row">
                                        <div className="col-lg-3 col-md-6 col-12">
                                            <div className="">
                                                <label className='form-label'>Service Type <span>*</span></label>
                                                <Select
                                                    className='custom-selector'
                                                    styles={customStyles}
                                                    options={servicetypeOptions}
                                                    value={servicetypeOptions.find(option => option.value === formik.values.service_type) || null} // Control the value based on Formik's state
                                                    onChange={(selectedOption) => {
                                                        formik.setFieldValue("charge_head", "")
                                                        formik.setFieldValue("service_type", selectedOption.value)
                                                    }} // Set the correct field in Formik
                                                    onBlur={formik.handleBlur}
                                                />
                                                {formik.touched.service_type && formik.errors.service_type ? (
                                                    <div className="error">{formik.errors.service_type}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        {showAirline ? <div className="col-lg-3 col-md-6 col-12">
                                            <div className="">
                                                <label className='form-label'>Airline Code & Name <span>*</span></label>
                                                <Select
                                                    disabled={!!initialAirlineCode}
                                                    className='custom-selector'
                                                    styles={customStyles}
                                                    options={airlineOptions}
                                                    isLoading={loadingAirline}
                                                    value={airlineOptions.find(option => option.value === formik.values.airline_code) || null} // Control the value based on Formik's state
                                                    onChange={(selectedOption) => formik.setFieldValue("airline_code", selectedOption.value)} // Set the correct field in Formik
                                                    onBlur={formik.handleBlur}
                                                />
                                                {formik.touched.airline_code && formik.errors.airline_code ? (
                                                    <div className="error">{formik.errors.airline_code}</div>
                                                ) : null}
                                            </div>
                                        </div> : null}
                                        {/* <div className="col-lg-3 col-md-6 col-12">
                                            <div className="input_box_section input_popup_rate">
                                                <label className='mb-0'>Airline Name <span>*</span></label>
                                                <input
                                                    className='form-control form-control-sm'
                                                    // maxLength={2}
                                                    type="text"
                                                    placeholder="Enter airline Name"
                                                // value={initialAirlineCode || formik.values.airline_code || ''} // Display airline_code
                                                // onChange={formik.handleChange}
                                                // onBlur={formik.handleBlur}
                                                // name="airline_code"
                                                // disabled={!!initialAirlineCode} // Disable only if initialAirlineCode is present
                                                // onKeyPress={(event) => {
                                                //     const inputValue = event.target.value;
                                                //     // Prevent space as the first character
                                                //     if (inputValue.length === 0 && event.key === ' ') {
                                                //         event.preventDefault();
                                                //     }
                                                // }}
                                                />
                                                {formik.touched.airline_code && formik.errors.airline_code ? (
                                                    <div className="error">{formik.errors.airline_code}</div>
                                                ) : null}
                                            </div>
                                        </div> */}
                                        <div className="col-lg-3 col-md-6 col-12">
                                            <div className="">
                                                <label className='form-label'>Charge Head <span>*</span></label>
                                                {/* <input
                                                    type="text"
                                                    className='form-control form-control-sm'
                                                    placeholder="Enter charge head"
                                                    value={formik.values.charge_head}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    name="charge_head"
                                                    onKeyPress={(event) => {
                                                        const inputValue = event.target.value;
                                                        // Prevent space as the first character
                                                        if (inputValue.length === 0 && event.key === ' ') {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                /> */}
                                                <Select
                                                    className='custom-selector'
                                                    options={chargeHeadOptions}
                                                    styles={customStyles}
                                                    value={chargeHeadOptions.find(option => option.value === formik.values.charge_head) || null} // Control the value based on Formik's state
                                                    onChange={(selectedOption) => formik.setFieldValue("charge_head", selectedOption.value)} // Set the correct field in Formik
                                                    onBlur={formik.handleBlur}
                                                />
                                                {formik.touched.charge_head && formik.errors.charge_head ? (
                                                    <div className="error">{formik.errors.charge_head}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-6 col-12">
                                            <div className="input_box_section input_popup_rate">
                                                <label className='form-label'>Chargeable Weight <span>*</span> </label>
                                                <input
                                                    className='form-control form-control-sm'
                                                    type="text"
                                                    placeholder="Enter Chargeable Weight"
                                                    value={formik.values.chargeable_weight}
                                                    maxLength={8}
                                                    onChange={(e) => {
                                                        const num = e.target.value.replace(/[^0-9]/g, '');
                                                        formik.setFieldValue('chargeable_weight', num);
                                                    }}
                                                    onBlur={formik.handleBlur}
                                                    name="chargeable_weight"
                                                    required
                                                    onKeyPress={(event) => {
                                                        const inputValue = event.target.value;
                                                        // Prevent space as the first character
                                                        if (inputValue.length === 0 && event.key === ' ') {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                />
                                                {formik.touched.chargeable_weight && formik.errors.chargeable_weight ? (
                                                    <div className="error">{formik.errors.chargeable_weight}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-6 col-12">
                                            <div className="input_box_section input_popup_rate">
                                                <label className='form-label'>Buying Price  </label>
                                                <input
                                                    className='form-control form-control-sm'
                                                    type="text"
                                                    placeholder="Enter buying price"
                                                    value={formik.values.buying_price}
                                                    maxLength={8}
                                                    onChange={(e) => {
                                                        const num = e.target.value.replace(/[^0-9]/g, '');
                                                        formik.setFieldValue('buying_price', num);
                                                    }}
                                                    onBlur={formik.handleBlur}
                                                    name="buying_price"
                                                    onKeyPress={(event) => {
                                                        const inputValue = event.target.value;
                                                        // Prevent space as the first character
                                                        if (inputValue.length === 0 && event.key === ' ') {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                />
                                                {formik.touched.buying_price && formik.errors.buying_price ? (
                                                    <div className="error">{formik.errors.buying_price}</div>
                                                ) : null}
                                            </div>
                                        </div>

                                        <div className="col-lg-3 col-md-6 col-12">
                                            <div className="input_box_section input_popup_rate">
                                                <label className='form-label'>Base Price </label>
                                                <input
                                                    className='form-control form-control-sm'
                                                    type="text"
                                                    placeholder="Enter base price"
                                                    maxLength={8}
                                                    value={formik.values.base_price}
                                                    onChange={(e) => {
                                                        const num = e.target.value.replace(/[^0-9]/g, '');
                                                        formik.setFieldValue('base_price', num);
                                                    }}
                                                    onBlur={formik.handleBlur}
                                                    name="base_price"
                                                    onKeyPress={(event) => {
                                                        const inputValue = event.target.value;
                                                        // Prevent space as the first character
                                                        if (inputValue.length === 0 && event.key === ' ') {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                />
                                                {formik.touched.base_price && formik.errors.base_price ? (
                                                    <div className="error">{formik.errors.base_price}</div>
                                                ) : null}
                                            </div>
                                        </div>




                                        {/* NEW: Pickup Price Field (Non-Mandatory) */}
                                        <div className="col-lg-3 col-md-6 col-12">
                                            <div className="input_box_section input_popup_rate">
                                                <label className='form-label'>Pickup Price</label>
                                                <input
                                                    className='form-control form-control-sm'
                                                    type="text"
                                                    placeholder="Enter pickup price"
                                                    maxLength={8}
                                                    value={formik.values.pickup_price}
                                                    onChange={(e) => {
                                                        const num = e.target.value.replace(/[^0-9]/g, '');
                                                        formik.setFieldValue('pickup_price', num);
                                                    }}
                                                    onBlur={formik.handleBlur}
                                                    name="pickup_price"
                                                />
                                                {formik.touched.pickup_price && formik.errors.pickup_price ? (
                                                    <div className="error">{formik.errors.pickup_price}</div>
                                                ) : null}
                                            </div>
                                        </div>

                                        {/* NEW: Drop Price Field (Non-Mandatory) */}
                                        <div className="col-lg-3 col-md-6 col-12">
                                            <div className="input_box_section input_popup_rate">
                                                <label className='form-label'>Drop Price</label>
                                                <input
                                                    className='form-control form-control-sm'
                                                    type="text"
                                                    placeholder="Enter drop price"
                                                    maxLength={8}
                                                    value={formik.values.drop_price}
                                                    onChange={(e) => {
                                                        const num = e.target.value.replace(/[^0-9]/g, '');
                                                        formik.setFieldValue('drop_price', num);
                                                    }}
                                                    onBlur={formik.handleBlur}
                                                    name="drop_price"
                                                />
                                                {formik.touched.drop_price && formik.errors.drop_price ? (
                                                    <div className="error">{formik.errors.drop_price}</div>
                                                ) : null}
                                            </div>
                                        </div>

                                        {/* NEW: Custom Clearance Charge Field (Non-Mandatory) */}
                                        <div className="col-lg-3 col-md-6 col-12">
                                            <div className="input_box_section input_popup_rate">
                                                <label className='form-label'>Custom Clearance Charge</label>
                                                <input
                                                    className='form-control form-control-sm'
                                                    type="text"
                                                    placeholder="Enter custom clearance charge"
                                                    maxLength={8}
                                                    value={formik.values.custom_clearance_charge}
                                                    onChange={(e) => {
                                                        const num = e.target.value.replace(/[^0-9]/g, '');
                                                        formik.setFieldValue('custom_clearance_charge', num);
                                                    }}
                                                    onBlur={formik.handleBlur}
                                                    name="custom_clearance_charge"
                                                />
                                                {formik.touched.custom_clearance_charge && formik.errors.custom_clearance_charge ? (
                                                    <div className="error">{formik.errors.custom_clearance_charge}</div>
                                                ) : null}
                                            </div>
                                        </div>

                                        {/* Surcharge - existing field */}
                                        {/* <div className="col-lg-3 col-md-6 col-12">
                                            <div className="input_box_section input_popup_rate">
                                                <label className='form-label'>Surcharge<span>*</span> </label>
                                                <input
                                                    type="text"
                                                    className='form-control form-control-sm'
                                                    placeholder="Enter Surcharge"
                                                    value={formik.values.surcharge}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    name="surcharge"
                                                    required
                                                    onKeyPress={(event) => {
                                                        const inputValue = event.target.value;
                                                        if (inputValue.length === 0 && event.key === ' ') {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                />
                                                {formik.touched.surcharge && formik.errors.surcharge ? (
                                                    <div className="error">{formik.errors.surcharge}</div>
                                                ) : null}
                                            </div>
                                        </div> */}
                                        {/* <div className="col-lg-3 col-md-6 col-12">
                                            <div className="input_box_section input_popup_rate">
                                                <label className='mb-0'>Selling Price <span>*</span></label>
                                                <input
                                                    type="text"
                                                    className='form-control form-control-sm'
                                                    placeholder="Enter selling price"
                                                    value={formik.values.selling_price}
                                                    onChange={(e) => {
                                                        const num = e.target.value.replace(/[^0-9]/g, '');
                                                        formik.setFieldValue('selling_price', num);
                                                    }}
                                                    onBlur={formik.handleBlur}
                                                    name="selling_price"
                                                    onKeyPress={(event) => {
                                                        const inputValue = event.target.value;
                                                        // Prevent space as the first character
                                                        if (inputValue.length === 0 && event.key === ' ') {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                />
                                                {formik.touched.selling_price && formik.errors.selling_price ? (
                                                    <div className="error">{formik.errors.selling_price}</div>
                                                ) : null}
                                            </div>
                                        </div> */}
                                        {/* Surcharge */}
                                        <div className="col-lg-3 col-md-6 col-12">
                                            <div className="input_box_section input_popup_rate">
                                                <label className='form-label'>Surcharge<span>*</span> </label>
                                                <input
                                                    type="text"
                                                    className='form-control form-control-sm'
                                                    placeholder="Enter Surcharge"
                                                    value={formik.values.surcharge}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    name="surcharge"
                                                    required
                                                    onKeyPress={(event) => {
                                                        const inputValue = event.target.value;
                                                        // Prevent space as the first character
                                                        if (inputValue.length === 0 && event.key === ' ') {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                />
                                                {formik.touched.surcharge && formik.errors.surcharge ? (
                                                    <div className="error">{formik.errors.surcharge}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        {/* AMS Charge (MAWB) */}
                                        <div className="col-lg-3 col-md-6 col-12">
                                            <div className="input_box_section input_popup_rate">
                                                <label className='form-label'>AMS Charge (MAWB)</label>
                                                <input
                                                    type="text"
                                                    className='form-control form-control-sm'
                                                    placeholder="Enter AMS (MAWB) charge"
                                                    value={formik.values.ams_charge_mawb}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    name="ams_charge_mawb"
                                                    onKeyPress={(event) => {
                                                        const inputValue = event.target.value;
                                                        // Prevent space as the first character
                                                        if (inputValue.length === 0 && event.key === ' ') {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                />

                                            </div>
                                        </div>
                                        {/* AMS Charge (HAWB */}
                                        <div className="col-lg-3 col-md-6 col-12">
                                            <div className="input_box_section input_popup_rate">
                                                <label className='form-label'>AMS Charge (HAWB)</label>
                                                <input
                                                    type="text"
                                                    className='form-control form-control-sm'
                                                    placeholder="Enter AMS (HAWB) charge"
                                                    value={formik.values.ams_charge_hawb}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    name="ams_charge_hawb"
                                                    onKeyPress={(event) => {
                                                        const inputValue = event.target.value;
                                                        // Prevent space as the first character
                                                        if (inputValue.length === 0 && event.key === ' ') {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                />

                                            </div>
                                        </div>

                                        <div className="col-lg-3 col-md-6 col-12">
                                            <div className="input_box_section input_popup_rate">
                                                <label className='form-label'>Narration</label>
                                                <input
                                                    type="text"
                                                    className='form-control form-control-sm'
                                                    placeholder="Enter narration"
                                                    value={formik.values.narration}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    name="narration"
                                                    onKeyPress={(event) => {
                                                        const inputValue = event.target.value;
                                                        // Prevent space as the first character
                                                        if (inputValue.length === 0 && event.key === ' ') {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                />
                                                {formik.touched.narration && formik.errors.narration ? (
                                                    <div className="error">{formik.errors.narration}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-6 col-12">
                                            <div className="input_box_section input_popup_rate">
                                                <label className='form-label'>Valid Upto <span>*</span></label>
                                                <DatePicker
                                                    className='form-control form-control-sm'
                                                    minDate={new Date()}
                                                    placeholderText='Enter valid upto'
                                                    style={{ width: '100%' }}
                                                    selected={formik.values.valid_upto}
                                                    onChange={(date) => {
                                                        const formattedDate = date.toISOString().split('T')[0];
                                                        formik.setFieldValue('valid_upto', formattedDate);
                                                    }}
                                                    onBlur={formik.handleBlur}
                                                    name="valid_upto"
                                                />
                                                {formik.touched.valid_upto && formik.errors.valid_upto ? (
                                                    <div className="error">{formik.errors.valid_upto}</div>
                                                ) : null}
                                            </div>
                                        </div>

                                        {/* <div className="col-md-12">
                          <div className="info-det-button-add">
                            <button type="button" onClick={() => formik.setFieldValue('tarrif_details', [...formik.values.tarrif_details, {}])}>
                              + Add
                            </button>
                          </div>
                        </div> */}
                                        <div className="col-md-12">
                                            <button className="btn btn-primary" type="submit" disabled={isSubmitting}>
                                                {isSubmitting ? <div><i className="fa fa-spinner fa-spin" /> Submit</div> : "Submit"}
                                            </button>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <div className="Air_Export_Form_bg">
                            <div className="Air_Export_bg_main">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="table_detail_tariff table-responsive">
                                            {/* <table className="posts-table geeks">
                            <thead>
                              <tr className="users-table-tariff n_detail_comp">
                                <th>Airline Code</th>
                                <th>Charge Head</th>
                                <th>Buyer Amount</th>
                                <th>Seller Amount</th>
                                <th>Narration</th>
                                <th>Valid Up To</th>
                                <th>Currency</th>
                                <th>Exchange Rate</th>
                                <th>Unit</th>
                                <th>FC Amount</th>
                                <th>Rate</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {updateTraficDetails.map((detail, index) => (

                                <tr key={index} className="main_table_row_new n_detail_comp">
                                  <td>{detail.airline_code}</td>
                                  <td>{detail.charge_head}</td>
                                  <td>{detail.buying_price}</td>
                                  <td>{detail.selling_price}</td>
                                  <td>{detail.narration}</td>
                                  <td>{detail.valid_upto}</td>
                                  <td>{detail.currency}</td>
                                  <td>{detail.exchange_rate}</td>
                                  <td>{detail.unit}</td>
                                  <td>{detail.fc_amount}</td>
                                  <td>{detail.rate}</td>
                                  <td>
                                    <div className="main_icon_click">
                                      <div ref={modalRef} style={{ cursor: "pointer" }} onClick={() => handleEditClick(detail)}>
                                        <img src="/img/edit-line.png" alt="edit" />
                                      </div>
                                      <div style={{ cursor: "pointer" }} onClick={() => handleDeleteClick(index)}>
                                        <img src="/img/delete-outline.png" alt="delete" />
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                              {
                                updateTraficDetails.map((detail, indexData) => {
                                  // tableDetailsId = detail.tableId;

                                  // Check the condition for matching tableId and return the row
                                  if (tableId === detail.tableId) {
                                    return (
                                      <tr key={indexData} className="main_table_row_new n_detail_comp">
                                        <td>{detail.airline_code}</td>
                                        <td>{detail.charge_head}</td>
                                        <td>{detail.buying_price}</td>
                                        <td>{detail.selling_price}</td>
                                        <td>{detail.narration}</td>
                                        <td>{detail.valid_upto}</td>
                                        <td>{detail.currency}</td>
                                        <td>{detail.exchange_rate}</td>
                                        <td>{detail.unit}</td>
                                        <td>{detail.fc_amount}</td>
                                        <td>{detail.rate}</td>
                                        <td>
                                          <div className="main_icon_click">
                                            <div style={{ cursor: "pointer" }} onClick={() => handleEditClick(detail)}>
                                              <img src="/img/edit-line.png" alt="edit" />
                                            </div>
                                            <div style={{ cursor: "pointer" }} onClick={() => handleDeleteClick(indexData)}>
                                              <img src="/img/delete-outline.png" alt="delete" />
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    );
                                  } else {
                                    return null; // Return null if the condition doesn't match
                                  }
                                })
                              }

                            </tbody>
                          </table> */}
                                            <table className="posts-table geeks w-100">
                                                <thead>
                                                    <tr className="users-table-tariff n_detail_comp">
                                                        <th>Service Type</th>
                                                        <th>Airline Code</th>
                                                        <th>Charge Head</th>
                                                        <th>Chargeable Weight</th>
                                                        <th>Surcharge</th>
                                                        <th>Buying Price</th>
                                                        <th>Base Price</th>
                                                        <th>Pickup Price</th>
                                                        <th>Drop Price</th>
                                                        <th>Custom Clearance</th>
                                                        <th>Narration</th>
                                                        <th>Valid Upto</th>
                                                        <th>Action</th>
                                                        {/* <th>Currency</th>
                                                        <th>Exchange Rate</th>
                                                        <th>Unit ID</th>
                                                        <th>FC Amount</th>
                                                        <th>Rate</th>
                                                        <th>Action</th> */}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {modalData?.length > 0 ? modalData.map((detail, indexData) => (
                                                        <tr key={indexData} className="main_table_row_new n_detail_comp">
                                                            <td>{detail.service_type}</td>
                                                            <td>{detail.airline_code ?? "-"}</td>
                                                            <td>{detail.charge_head}</td>
                                                            <td>{detail.chargeable_weight}</td>
                                                            <td>{detail.surcharge}</td>
                                                            <td>{detail.buying_price}</td>
                                                            <td>{detail.base_price}</td>
                                                            <td>{detail.pickup_price || '-'}</td>       
                                                            <td>{detail.drop_price || '-'}</td>            
                                                            <td>{detail.custom_clearance_charge || '-'}</td>
                                                            <td>{detail.narration}</td>
                                                            <td>{detail.valid_upto ? format(new Date(detail.valid_upto), 'dd/MM/yyyy') : 'N/A'}</td>
                                                            {/* <td>{detail.currency}</td>
                                                            <td>{detail.exchange_rate}</td>
                                                            <td>{detail.unit_id}</td>
                                                            <td>{detail.fc_amount}</td>
                                                            <td>{detail.rate}</td> */}
                                                            <td>
                                                                <td>
                                                                    <div className="main_icon_click">
                                                                        <div style={{ cursor: "pointer" }} onClick={() => handleEditClick(detail)}>
                                                                            <span title="Edit">
                                                                                <img src="/img/edit-line.png" alt="edit" />
                                                                            </span>
                                                                        </div>
                                                                        <div style={{ cursor: "pointer" }} onClick={() => handleDeleteClick(indexData)}>
                                                                            <span title="Delete">
                                                                                <img src="/img/delete-outline.png" alt="delete" />
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </td>
                                                        </tr>
                                                    )) : (
                                                        <tr>
                                                            <td colSpan="12" className="text-center">No data available</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>

                                            {/* {Object.keys(groupedData).map((airlineCode) => (

                            <table className="posts-table geeks">
                              <thead>
                                <tr className='users-table-tariff n_detail_comp'>
                                  <th>Airline Code</th>
                                  <th>Charge Head</th>
                                  <th>Buying Price</th>
                                  <th>Selling Price</th>
                                  <th>Narration</th>
                                  <th>Valid Upto</th>
                                  <th>Currency</th>
                                  <th>Exchange Rate</th>
                                  <th>Unit</th>
                                  <th>FC Amount</th>
                                  <th>Rate</th>
                                  <th>Actions</th>
                                </tr>
                              </thead>
                              <tbody>
                                {groupedData[airlineCode].map((detail, index) => (
                                  <tr key={index} className="main_table_row_new n_detail_comp">
                                    <td>{detail.airline_code}</td>
                                    <td>{detail.charge_head}</td>
                                    <td>{detail.buying_price}</td>
                                    <td>{detail.selling_price}</td>
                                    <td>{detail.narration}</td>
                                    <td>{detail.valid_upto
                                      ? format(new Date(detail.valid_upto), 'dd/MM/yyyy')
                                      : 'N/A'}</td>
                                    <td>{detail.currency}</td>
                                    <td>{detail.exchange_rate}</td>
                                    <td>{detail.unit}</td>
                                    <td>{detail.fc_amount}</td>
                                    <td>{detail.rate}</td>
                                    <td>
                                      <div className="main_icon_click">
                                        <div ref={modalRef} style={{ cursor: "pointer" }} onClick={() => handleEditClick(detail)}>
                                          <img src="/img/edit-line.png" alt="edit" />
                                        </div>
                                        <div style={{ cursor: "pointer" }} onClick={() => handleDeleteClick(index)}>
                                          <img src="/img/delete-outline.png" alt="delete" />
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>

                          ))} */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="main-nav-det-button text-right main-Export-button cursor-pointer">
                                <a data-bs-dismiss="modal" ref={closeButtonRef}>Close</a>
                            </div> */}
                        </div>

                    </div></Modal.Body>
                {/* <Modal.Footer>
                    <button variant="secondary" onClick={handleClose}>
                        Close
                    </button>
                    <button variant="primary" onClick={handleClose}>
                        Save Changes
                    </button>
                </Modal.Footer> */}
            </Modal>
            {/* <div className="modal fade" id={modal} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog detail_popup_width modal-xl modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="btn-close-new-section">
                            <button type="button" className="btn-close" data-bs-dismiss="modal" />
                        </div>
                        <div className="modal-body detail_con_popup_main">
                            <div className="main-nav-det">
                                <h4>New Rate</h4>
                            </div>
                            <div className="main_detail_form " id="main_id_sec">
                                <form onSubmit={formik.handleSubmit}>
                                    <FocusError formik={formik} />
                                    <div className="Air_Export_Form_bg">
                                        <div className="Air_Export_bg_main">
                                            <div className="row">
                                                <div className="col-lg-3 col-md-6 col-12">
                                                    <div className="input_box_section input_popup_rate">
                                                        <label>Airline Code <span>*</span></label>
                                                        <input
                                                            maxLength={2}
                                                            type="text"
                                                            placeholder="Enter airline code"
                                                            value={initialAirlineCode || formik.values.airline_code || ''} // Display airline_code
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            name="airline_code"
                                                            disabled={!!initialAirlineCode} 
                                                            onKeyPress={(event) => {
                                                                const inputValue = event.target.value;
                                                                if (inputValue.length === 0 && event.key === ' ') {
                                                                    event.preventDefault();
                                                                }
                                                            }}
                                                        />
                                                        {formik.touched.airline_code && formik.errors.airline_code ? (
                                                            <div className="error">{formik.errors.airline_code}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 col-md-6 col-12">
                                                    <div className="input_box_section input_popup_rate">
                                                        <label>Charge Head <span>*</span></label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter charge head"
                                                            value={formik.values.charge_head}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            name="charge_head"
                                                            onKeyPress={(event) => {
                                                                const inputValue = event.target.value;
                                                                if (inputValue.length === 0 && event.key === ' ') {
                                                                    event.preventDefault();
                                                                }
                                                            }}
                                                        />
                                                        {formik.touched.charge_head && formik.errors.charge_head ? (
                                                            <div className="error">{formik.errors.charge_head}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 col-md-6 col-12">
                                                    <div className="input_box_section input_popup_rate">
                                                        <label>Buying Price </label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter buying price"
                                                            value={formik.values.buying_price}
                                                            onChange={(e) => {
                                                                const num = e.target.value.replace(/[^0-9]/g, '');
                                                                formik.setFieldValue('buying_price', num);
                                                            }}
                                                            onBlur={formik.handleBlur}
                                                            name="buying_price"
                                                            onKeyPress={(event) => {
                                                                const inputValue = event.target.value;
                                                                if (inputValue.length === 0 && event.key === ' ') {
                                                                    event.preventDefault();
                                                                }
                                                            }}
                                                        />
                                                        {formik.touched.buying_price && formik.errors.buying_price ? (
                                                            <div className="error">{formik.errors.buying_price}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 col-md-6 col-12">
                                                    <div className="input_box_section input_popup_rate">
                                                        <label>Selling Price <span>*</span></label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter selling price"
                                                            value={formik.values.selling_price}
                                                            onChange={(e) => {
                                                                const num = e.target.value.replace(/[^0-9]/g, '');
                                                                formik.setFieldValue('selling_price', num);
                                                            }}
                                                            onBlur={formik.handleBlur}
                                                            name="selling_price"
                                                            onKeyPress={(event) => {
                                                                const inputValue = event.target.value;
                                                                if (inputValue.length === 0 && event.key === ' ') {
                                                                    event.preventDefault();
                                                                }
                                                            }}
                                                        />
                                                        {formik.touched.selling_price && formik.errors.selling_price ? (
                                                            <div className="error">{formik.errors.selling_price}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 col-md-6 col-12">
                                                    <div className="input_box_section input_popup_rate">
                                                        <label>Narration</label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter narration"
                                                            value={formik.values.narration}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            name="narration"
                                                            onKeyPress={(event) => {
                                                                const inputValue = event.target.value;
                                                                if (inputValue.length === 0 && event.key === ' ') {
                                                                    event.preventDefault();
                                                                }
                                                            }}
                                                        />
                                                        {formik.touched.narration && formik.errors.narration ? (
                                                            <div className="error">{formik.errors.narration}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 col-md-6 col-12">
                                                    <div className="input_box_section input_popup_rate">
                                                        <label>Valid Upto <span>*</span></label>
                                                        <DatePicker
                                                            minDate={new Date()}
                                                            placeholderText='Enter valid upto'
                                                            style={{ width: '100%' }}
                                                            selected={formik.values.valid_upto}
                                                            onChange={(date) => {
                                                                const formattedDate = date.toISOString().split('T')[0];
                                                                formik.setFieldValue('valid_upto', formattedDate);
                                                            }}
                                                            onBlur={formik.handleBlur}
                                                            name="valid_upto"
                                                        />
                                                        {formik.touched.valid_upto && formik.errors.valid_upto ? (
                                                            <div className="error">{formik.errors.valid_upto}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 col-md-6 col-12">
                                                    <div className="input_box_section input_popup_rate">
                                                        <label>Currency</label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter currency"
                                                            value={formik.values.currency}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            name="currency"
                                                            onKeyPress={(event) => {
                                                                const inputValue = event.target.value;
                                                                if (inputValue.length === 0 && event.key === ' ') {
                                                                    event.preventDefault();
                                                                }
                                                            }}
                                                        />
                                                        {formik.touched.currency && formik.errors.currency ? (
                                                            <div className="error">{formik.errors.currency}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 col-md-6 col-12">
                                                    <div className="input_box_section input_popup_rate">
                                                        <label>Exchange Rate</label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter exchange rate"
                                                            value={formik.values.exchange_rate}
                                                            onChange={(e) => {
                                                                const num = e.target.value.replace(/[^0-9]/g, '');
                                                                formik.setFieldValue('exchange_rate', num);
                                                            }}
                                                            onBlur={formik.handleBlur}
                                                            name="exchange_rate"
                                                            onKeyPress={(event) => {
                                                                const inputValue = event.target.value;
                                                                if (inputValue.length === 0 && event.key === ' ') {
                                                                    event.preventDefault();
                                                                }
                                                            }}
                                                        />
                                                        {formik.touched.exchange_rate && formik.errors.exchange_rate ? (
                                                            <div className="error">{formik.errors.exchange_rate}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 col-md-6 col-12">
                                                    <div className="input_box_section ">
                                                        <label>Unit</label>
                                                        <Select
                                                            className="mt-2"
                                                            options={weightUnit}
                                                            value={weightUnit.find(option => option.WeightUnitId === formik.values.unit_id) || null} // Control the value based on Formik's state
                                                            onChange={(selectedOption) => formik.setFieldValue("unit_id", selectedOption.WeightUnitId)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                    
                                                        {formik.touched.unit_id && formik.errors.unit_id ? (
                                                            <div className="error">{formik.errors.unit_id}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 col-md-6 col-12">
                                                    <div className="input_box_section input_popup_rate">
                                                        <label>FC Amount</label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter FC amount"
                                                            value={formik.values.fc_amount}
                                                            onChange={(e) => {
                                                                const num = e.target.value.replace(/[^0-9]/g, '');
                                                                formik.setFieldValue('fc_amount', num);
                                                            }}
                                                            onBlur={formik.handleBlur}
                                                            name="fc_amount"
                                                            onKeyPress={(event) => {
                                                                const inputValue = event.target.value;
                                                                if (inputValue.length === 0 && event.key === ' ') {
                                                                    event.preventDefault();
                                                                }
                                                            }}
                                                        />
                                                        {formik.touched.fc_amount && formik.errors.fc_amount ? (
                                                            <div className="error">{formik.errors.fc_amount}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 col-md-6 col-12">
                                                    <div className="input_box_section input_popup_rate">
                                                        <label>Rate</label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter rate"
                                                            value={formik.values.rate}
                                                            onChange={(e) => {
                                                                const num = e.target.value.replace(/[^0-9]/g, '');
                                                                formik.setFieldValue('rate', num);
                                                            }}
                                                            onBlur={formik.handleBlur}
                                                            name="rate"
                                                            onKeyPress={(event) => {
                                                                const inputValue = event.target.value;
                                                                if (inputValue.length === 0 && event.key === ' ') {
                                                                    event.preventDefault();
                                                                }
                                                            }}
                                                        />
                                                        {formik.touched.rate && formik.errors.rate ? (
                                                            <div className="error">{formik.errors.rate}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 col-md-6 col-12">
                                                    <div className="">
                                                        <label>Cargo Type</label>
                                                        <Select
                                                            className='mt-2'
                                                            options={cargoType}
                                                            value={cargoType.find(option => option.cargoId === formik.values.cargo_type_id) || null}
                                                            onChange={(selectedOption) =>
                                                                formik.setFieldValue(
                                                                    "cargo_type_id",
                                                                    selectedOption.cargoId
                                                                )
                                                            }
                                                            onBlur={formik.handleBlur}
                                                        />
                                                      
                                                    </div>
                                                </div>
                                              
                                                <div className="col-md-12">
                                                    <button className="btn search-btn" type="submit" disabled={isSubmitting}>
                                                        {isSubmitting ? <div><i className="fa fa-spinner fa-spin" /> Submit</div> : "Submit"}
                                                    </button>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                                <div className="Air_Export_Form_bg">
                                    <div className="Air_Export_bg_main">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="table_detail_tariff table-responsive">
                                                 
                                                    <table className="posts-table geeks">
                                                        <thead>
                                                            <tr className="users-table-tariff n_detail_comp">
                                                                <th>Airline Code</th>
                                                                <th>Charge Head</th>
                                                                <th>Buying Price</th>
                                                                <th>Selling Price</th>
                                                                <th>Narration</th>
                                                                <th>Valid Upto</th>
                                                                <th>Currency</th>
                                                                <th>Exchange Rate</th>
                                                                <th>Unit ID</th>
                                                                <th>FC Amount</th>
                                                                <th>Rate</th>
                                                                <th>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {modalData?.length > 0 ? modalData.map((detail, indexData) => (
                                                                <tr key={indexData} className="main_table_row_new n_detail_comp">
                                                                    <td>{detail.airline_code}</td>
                                                                    <td>{detail.charge_head}</td>
                                                                    <td>{detail.buying_price}</td>
                                                                    <td>{detail.selling_price}</td>
                                                                    <td>{detail.narration}</td>
                                                                    <td>{detail.valid_upto ? format(new Date(detail.valid_upto), 'dd/MM/yyyy') : 'N/A'}</td>
                                                                    <td>{detail.currency}</td>
                                                                    <td>{detail.exchange_rate}</td>
                                                                    <td>{detail.unit_id}</td>
                                                                    <td>{detail.fc_amount}</td>
                                                                    <td>{detail.rate}</td>
                                                                    <td>
                                                                        <td>
                                                                            <div className="main_icon_click">
                                                                                <div style={{ cursor: "pointer" }} onClick={() => handleEditClick(detail)}>
                                                                                    <img src="/img/edit-line.png" alt="edit" />
                                                                                </div>
                                                                                <div style={{ cursor: "pointer" }} onClick={() => handleDeleteClick(indexData)}>
                                                                                    <img src="/img/delete-outline.png" alt="delete" />
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                    </td>
                                                                </tr>
                                                            )) : (
                                                                <tr>
                                                                    <td colSpan="12" className="text-center">No data available</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="main-nav-det-button text-right main-Export-button cursor-pointer">
                                        <a data-bs-dismiss="modal" ref={closeButtonRef}>Close</a>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div> */}

        </>
    )
}

export default ImportTarrifDetailsModal2